import http from "./http";
import * as authApi from "api/endpoints/auth";

let tokenInterceptor = null;
let baseUrlInterceptor = null;
// let unauthorizedInterceptor = null;

export function setupTokenInterceptor() {
  http.interceptors.request.eject(tokenInterceptor);
  tokenInterceptor = http.interceptors.request.use(async function (config) {
    const session = await authApi.currentSession();
    const idToken = session.getIdToken();
    const jwtToken = idToken.getJwtToken();
    config.headers.Authorization = jwtToken;
    return config;
  });
}

export async function setBaseUrl(baseURL) {
  http.interceptors.request.eject(baseUrlInterceptor);
  baseUrlInterceptor = http.interceptors.request.use(async function (config) {
    config.baseURL = baseURL;
    return config;
  });
}

// export async function setupUnauthorizedInterceptor() {
//   http.interceptors.request.eject(unauthorizedInterceptor);

//   unauthorizedInterceptor = http.interceptors.response.use(
//     (response) => response,
//     (error) => {
//       if (error.response.status === 403) {
//         window.location = "/login";
//       }
//     }
//   );
// }
